import Vue from 'vue';

// 获取cookie信息
Vue.prototype.$getCookie = (c_name) => { //获取个人信息解码
    var name = c_name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = decodeURIComponent(ca[i].trim()); // 解码
      if (c.indexOf(name) == 0) {
        // console.log(JSON.parse(c.substring(name.length, c.length)))
        return JSON.parse(c.substring(name.length, c.length));
      }
    }
    return "";
}

// 深拷贝
Vue.prototype.$deepClone = (obj) => {
    var _obj = JSON.stringify(obj),
    objClone = JSON.parse(_obj);
    return objClone;
}
 //时间转换
Vue.prototype.$dateTime = e => {
    var date = new Date(e),
      Y = date.getFullYear() + '-',
      M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-',
      D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()),
      h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':',
      m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()),
      s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return {
        date: Y + M + D, //日期
        time: h + m, //时间
        seconds: s, // 秒
    }
}
// 分钟转换
Vue.prototype.$formatSeconds = minutes => { 
  return {
    hour: Math.floor(minutes / 60),
    branch: minutes % 60
  }
}
// 分钟转换
Vue.prototype.$formaTime = minutes => { 
  return (Math.floor(minutes / 60)) + '小时' + (minutes % 60) + '分钟'
}

// 分钟转换
Vue.prototype.$formaTimeEn = minutes => { 
  return (Math.floor(minutes / 60)) + 'h' + (minutes % 60) + 'min'
}


